import React, { type Dispatch } from 'react';

import { MobilePopupBottom } from '@lt/components';
import { useTranslation } from '@lt/localization';
import type { SavedTourist } from 'src/routes/Checkout/store/client/types';
import type { DocType } from 'src/components/Tourists/types';
import { equalsIgnoreCase } from 'src/utils/stringUtils';
import SavedTouristOptionBody from '../SavedTouristOptionBody';

import { TEST_ID_SAVED_TOURIST_MOBILE_MENU_TITLE } from './constants';
import styles from './mobileMenu.module.css';

type Props = {
  showMenu: boolean;
  setShowMenu: Dispatch<boolean>;

  docType: DocType;

  tourists: SavedTourist[];
  deleteSavedTourist: (tourist: SavedTourist) => void;
  // TODO: change any to tourist type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClickOption: (tourist) => void;
};

const MobileMenu = ({
  tourists,
  deleteSavedTourist,
  showMenu,
  setShowMenu,
  onClickOption,
  docType,
}: Props) => {
  const { t } = useTranslation();

  const options = tourists?.filter((tourist) => {
    const docTypeMatches = equalsIgnoreCase(docType, tourist.docType);
    return docTypeMatches;
  });

  return (
    <MobilePopupBottom
      className={styles.container}
      visible={showMenu}
      onClick={() => setShowMenu(false)}
      options={{ showHandlebar: true }}
    >
      <p
        className={styles.title}
        data-testid={TEST_ID_SAVED_TOURIST_MOBILE_MENU_TITLE}
      >
        {t('checkout.touristForm.name.savedTourists')}
      </p>
      {options?.map((tourist) => (
        <SavedTouristOptionBody
          key={`saved-tourist-${tourist?.id}`}
          data={tourist}
          onClickOption={() => {
            onClickOption({
              ...tourist,
            });
            setShowMenu(false);
          }}
          deleteSavedTourist={deleteSavedTourist}
          isMobile
        />
      ))}
    </MobilePopupBottom>
  );
};

export default MobileMenu;
